
//
// Interpolation helper functions
//

InterpolationHelper = { };

//Interpolate a line between P1 and P2
//Where:
//	P1 has { x: float, y: float }
//	P2 has { x: float, y: float }
//	delta is a percentage (0.0 -> 1.0)
//Returns:
//	{ x: float, y: float }

InterpolationHelper.Linear = function(P1, P2, delta) {
	var x = (P1.x + ((P2.x - P1.x) * delta));
	var y = (P1.y + ((P2.y - P1.y) * delta));
	
	return { x: x, y: y };
};

//Interpolate a curve between P1 and P2
//Where:
//	P0 has { x: float, y: float } and is used as the left-hand side control point
//	P1 has { x: float, y: float }
//	P2 has { x: float, y: float }
//	P3 has { x: float, y: float } and is used as the right-hand side control point
//	delta is a percentage (0.0 -> 1.0)
//Returns:
//	{ x: float, y: float }

InterpolationHelper.CatmullRom = function(P0, P1, P2, P3, delta) {
	var delta2 = (delta * delta);
	var delta3 = (delta * delta * delta);
	
	var f1 = ((-0.5 * delta3) + delta2 - (0.5 * delta));
	var f2 = ((1.5 * delta3) - (2.5 * delta2) + 1.0);
	var f3 = ((-1.5 * delta3) + (2.0 * delta2) + (0.5 * delta));
	var f4 =  ((0.5 * delta3) - (0.5 * delta2));
	
	var x = ((P0.x * f1) + (P1.x * f2) + (P2.x * f3) + (P3.x * f4));
	var y = ((P0.y * f1) + (P1.y * f2) + (P2.y * f3) + (P3.y * f4));
	
	return { x: x, y: y };
};

//Interpolate from P1 to P2 then back again in a sine curve
//	P1 has { x: float, y: float }
//	P2 has { x: float, y: float }
//	delta is a percentage (0.0 -> 1.0)
//Returns:
//	{ x: float, y: float }

InterpolationHelper.Bounce = function(P1, P2, delta) {

    var x = InterpolationHelper.interpolateSine(P1.x,P2.x,delta);
    var y = InterpolationHelper.interpolateSine(P1.y,P2.y,delta);

    return { x: x, y: y };
};

InterpolationHelper.Shake = function(P1, P2, delta, frequency) {

    var x = (P1.x + ((P2.x - P1.x) * Math.sin(delta*(Math.PI*2) * frequency)));
    var y = (P1.y + ((P2.y - P1.y) * Math.sin(delta*(Math.PI*2) * frequency)));

    return { x: x, y: y };
};

InterpolationHelper.interpolateSine = function(P1,P2,delta){
	return (P1 + ((P2 - P1) * Math.sin(delta*Math.PI)));
};

InterpolationHelper.interpolateHalfSine = function(P1,P2,delta){
	return (P1 + ((P2 - P1) * Math.sin(delta*(Math.PI/2))));
};

InterpolationHelper.interpolateSineProgress = function(linearProgress){
    return (1 + Math.sin(Math.PI * 1.5 + Math.PI * linearProgress)) / 2;
};
